/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">Sw1</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Complete PAT on R1 (ACL 192, e0/0)</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Done?1:0 }}/1</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: complete Task 3 first, then <code>sh ip nat translations</code> on R1</p>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">NTP — R1 master, Sw1 client</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2R1Items" :key="'t2r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2Sw1Items" :key="'t2sw1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: <code>show ntp status</code> on Sw1 after ~1 min</p>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">DHCP relay agent on Sw1 e0/1</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task3Items" :key="'t3-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">PC1 should now receive 192.168.1.x via DHCP from R1</p>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">Complete SSH on Sw1 — RSA 2048, SSHv2</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task4Items" :key="'t4-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: on R1 run <code>ssh -l CCNA 192.168.1.1</code></p>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [r1Completion.saved,sw1Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="dk in ['r1','sw1']" :key="'s-'+dk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(dk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(dk).saved)"></div>
                    <code class="text-base" :class="getComp(dk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'"  key="r1"  id="r1_terminal"  :commands="r1Commands"  :prompt="r1Prompt"  :show-intro="true" intro="Cisco IOS Software — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw1" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the checklist. Use show/ssh to verify.';

const mkCommands = (dev, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(dev),
  configure:  (x) => vm.iosConfigure(dev, x),
  conf:       (x) => vm.iosConfigure(dev, x),
  interface:  (x) => vm.iosInterface(dev, x),
  int:        (x) => vm.iosInterface(dev, x),
  ip:         (x) => vm.iosIp(dev, x),
  ntp:        (x) => vm.iosNtp(dev, x),
  crypto:     (x) => vm.iosCrypto(dev, x),
  ssh:        (x) => vm.iosSsh(dev, x),
  show:       (x) => vm.iosShow(dev, x),
  sh:         (x) => vm.iosShow(dev, x),
  exit:       () => vm.iosExit(dev),
  end:        () => vm.iosEnd(dev),
  copy:       (x) => vm.iosCopy(dev, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/NAT_DHCP_SSH_Simulation.png',
      sel: 'r1',
      totalScore: 0,

      r1:  { mode: 'exec', currentIf: null },
      sw1: { mode: 'exec', currentIf: null },

      // r1(3) + sw1(6) = 9 total
      r1Completion:  { natOverload: false, ntpMaster: false, saved: false },
      sw1Completion: { ntpServer: false, e01If: false, helperAddr: false, cryptoKey: false, sshV2: false, saved: false },

      r1Commands: null, sw1Commands: null,

      task1Items:   [{ key: 'natOverload', label: 'ip nat inside source list 192 interface e0/0 overload' }],
      task2R1Items: [{ key: 'ntpMaster',   label: 'ntp master' }],
      task2Sw1Items:[{ key: 'ntpServer',   label: 'ntp server 209.165.202.134' }],
      task3Items: [
        { key: 'e01If',      label: 'interface e0/1' },
        { key: 'helperAddr', label: 'ip helper-address 172.16.0.9' },
      ],
      task4Items: [
        { key: 'cryptoKey', label: 'crypto key generate rsa modulus 2048' },
        { key: 'sshV2',     label: 'ip ssh version 2' },
      ],
    };
  },

  computed: {
    r1Prompt()  { const m=this.r1.mode;  return m==='config-if'?'R1(config-if)#':m==='config'?'R1(config)#':'R1#'; },
    sw1Prompt() { const m=this.sw1.mode; return m==='config-if'?'Sw1(config-if)#':m==='config'?'Sw1(config)#':'Sw1#'; },

    task1Done()     { return !!this.r1Completion.natOverload; },
    task2Progress() { return [this.r1Completion.ntpMaster, this.sw1Completion.ntpServer].filter(Boolean).length; },
    task2Done()     { return this.task2Progress === 2; },
    task3Progress() { return [this.sw1Completion.e01If, this.sw1Completion.helperAddr].filter(Boolean).length; },
    task3Done()     { return this.task3Progress === 2; },
    task4Progress() { return [this.sw1Completion.cryptoKey, this.sw1Completion.sshV2].filter(Boolean).length; },
    task4Done()     { return this.task4Progress === 2; },
    saveDone()      { return this.r1Completion.saved && this.sw1Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands  = mkCommands('r1', this);
    this.sw1Commands = mkCommands('sw1', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },
    devLabel(k) { return k === 'r1' ? 'R1' : 'Sw1'; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },
    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },
    normalizeIf(ifStr) {
      return (ifStr||'').toLowerCase()
        .replace(/^gigabitethernet/,'').replace(/^fastethernet/,'').replace(/^ethernet/,'')
        .replace(/^gi(?=\d)/,'').replace(/^fa(?=\d)/,'').replace(/^e(?=\d)/,'').replace(/^g(?=\d)/,'')
        .trim();
    },
    updateScore() {
      const score = Object.values(this.r1Completion).filter(Boolean).length +
                    Object.values(this.sw1Completion).filter(Boolean).length;
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 9) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(dev) { this[dev].mode = 'exec'; return createStdout(''); },

    iosConfigure(dev, x) {
      if (this[dev].mode !== 'exec') return createStderr('% Already in configuration mode — type "end" first');
      if (x._[1] === 'terminal' || x._[1] === 't') { this[dev].mode = 'config'; return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.'); }
      return createStderr('% Invalid input detected');
    },

    iosExit(dev) {
      const s = this[dev];
      if (s.mode === 'config-if') { s.mode = 'config'; s.currentIf = null; }
      else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },
    iosEnd(dev) { this[dev].mode = 'exec'; this[dev].currentIf = null; return createStdout(''); },

    iosInterface(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config' && s.mode !== 'config-if') return createStderr('% Must be in configuration mode');
      let ifArg = String(x._[1]||'');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) ifArg = ifArg + x._[2];
      if (ifArg.toLowerCase() === 'vlan' && x._[2]) ifArg = 'vlan' + x._[2];
      const ifNorm = this.normalizeIf(ifArg) || ifArg.toLowerCase();
      s.mode = 'config-if'; s.currentIf = ifNorm;
      const c = this[dev + 'Completion'];
      if (dev === 'sw1' && ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      return createStdout('');
    },

    iosIp(dev, x) {
      const s = this[dev];
      const sub1=(x._[1]||'').toLowerCase(), sub2=(x._[2]||'').toLowerCase(), sub3=(x._[3]||'').toLowerCase();
      const c = this[dev + 'Completion'];

      if (s.mode === 'config') {
        // ip nat inside source list 192 interface e0/0 overload
        if (sub1 === 'nat' && sub2 === 'inside' && sub3 === 'source') {
          const list = String(x._[5]||''), ifArg = String(x._[7]||''), ovl = (x._[8]||'').toLowerCase();
          if (dev === 'r1' && list === '192' && this.normalizeIf(ifArg) === '0/0' && ovl === 'overload' && !c.natOverload) {
            c.natOverload = true; this.updateScore();
            return createStdout(this.guide(
              'PAT configured — hosts matching ACL 192 share R1 e0/0\'s IP with port multiplexing (OVERLOAD). ' +
              'Note: interface/ACL pre-configuration was already done. → Complete Task 3 (DHCP relay), then verify with "sh ip nat translations".'
            ));
          }
          return createStdout('');
        }
        // ip ssh version 2
        if (sub1 === 'ssh' && sub2 === 'version' && String(x._[3]||'') === '2') {
          if (dev === 'sw1' && !c.sshV2) {
            c.sshV2 = true; this.updateScore();
            return createStdout(this.guide('SSHv2 enabled on Sw1. → Verify from R1: "end" then "ssh -l CCNA 192.168.1.1". → Save.'));
          }
          return createStdout('');
        }
        return createStderr('% Invalid input detected');
      }

      if (s.mode === 'config-if') {
        // ip helper-address 172.16.0.9
        if (sub1 === 'helper-address') {
          const addr = String(x._[2]||'');
          if (dev === 'sw1' && addr === '172.16.0.9' && s.currentIf === '0/1' && !c.helperAddr) {
            c.helperAddr = true; this.updateScore();
            return createStdout(this.guide(
              'DHCP relay configured — Sw1 forwards DHCP broadcasts on e0/1 to R1\'s DHCP server at 172.16.0.9. ' +
              'PC1 should now receive an IP from R1\'s pool (192.168.1.0/24). → Complete Task 4: SSH on Sw1.'
            ));
          }
          return createStdout('');
        }
        return createStderr('% Invalid input detected');
      }

      return createStderr('% Invalid input detected');
    },

    iosNtp(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const sub1 = (x._[1]||'').toLowerCase();
      const c = this[dev + 'Completion'];

      if (sub1 === 'master') {
        if (dev === 'r1' && !c.ntpMaster) {
          c.ntpMaster = true; this.updateScore();
          return createStdout(this.guide(
            'R1 designated as NTP master (stratum 8). R1 will serve time to NTP clients. ' +
            'Note: "ntp source-interface Loopback0" is not supported in Packet Tracer — skip it. → Configure NTP client on Sw1: "ntp server 209.165.202.134".'
          ));
        }
        return createStdout('');
      }

      // ntp source-interface (unsupported in PT — accept silently)
      if (sub1 === 'source-interface' || sub1 === 'source') {
        return createStdout(this.guide('Note: "ntp source-interface" is not supported in Packet Tracer and is ignored. → Configure NTP client on Sw1.'));
      }

      if (sub1 === 'server') {
        const addr = String(x._[2]||'');
        if (dev === 'sw1' && addr === '209.165.202.134' && !c.ntpServer) {
          c.ntpServer = true; this.updateScore();
          return createStdout(this.guide('Sw1 NTP client pointing to 209.165.202.134 (R1 loopback). Wait ~1 min then run "show ntp status" — look for "Clock is synchronized".'));
        }
        return createStdout('');
      }

      return createStdout('');
    },

    iosCrypto(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      if ((x._[1]||'').toLowerCase() !== 'key' || (x._[2]||'').toLowerCase() !== 'generate' || (x._[3]||'').toLowerCase() !== 'rsa') {
        return createStderr('% Invalid input detected');
      }
      const c = this[dev + 'Completion'];
      if (dev === 'sw1') {
        const sub4 = (x._[4]||'').toLowerCase();
        const bits  = sub4 === 'general-keys' ? String(x._[6]||'') : String(x._[5]||'');
        if (bits === '2048' && !c.cryptoKey) {
          c.cryptoKey = true; this.updateScore();
          return createStdout(
            'The name for the keys will be: Sw1.<domain><br>% Generating 2048 bit RSA keys...<br>[OK]' +
            this.guide('RSA key pair generated. Sw1 was pre-configured with hostname and domain name. → "ip ssh version 2".')
          );
        }
      }
      return createStdout('');
    },

    iosSsh(dev, x) {
      const s = this[dev];
      if (s.mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first');
      const param = (x._[1]||'').toLowerCase(), user = String(x._[2]||''), target = String(x._[3]||'');
      if (dev === 'r1' && param === '-l' && user.toLowerCase() === 'ccna' && target === '192.168.1.1') {
        const c = this.sw1Completion;
        if (c.cryptoKey && c.sshV2) {
          return createStdout('Password: <br>Sw1#' + this.guide('SSH to Sw1 successful! User "CCNA" is logged in.'));
        }
        return createStdout('ssh: connect to host 192.168.1.1 port 22: Connection refused' + this.guide('SSH not ready — complete Task 4 on Sw1 first.'));
      }
      return createStdout('% Connection failed');
    },

    iosShow(dev, x) {
      const sub1=(x._[1]||'').toLowerCase(), sub2=(x._[2]||'').toLowerCase(), sub3=(x._[3]||'').toLowerCase();

      // show ip nat translations
      if (sub1 === 'ip' && sub2 === 'nat' && sub3 === 'translations') {
        if (this.r1Completion.natOverload && this.sw1Completion.helperAddr) {
          return createStdout(
            'Pro&nbsp;&nbsp;Inside global&nbsp;Inside local&nbsp;&nbsp;&nbsp;&nbsp;Outside local&nbsp;&nbsp;Outside global<br>' +
            'icmp&nbsp;10.0.18.9:2&nbsp;&nbsp;&nbsp;192.168.1.11:2&nbsp;&nbsp;10.0.18.10:2&nbsp;&nbsp;&nbsp;10.0.18.10:2<br>' +
            'icmp&nbsp;10.0.18.9:3&nbsp;&nbsp;&nbsp;192.168.1.11:3&nbsp;&nbsp;10.0.18.10:3&nbsp;&nbsp;&nbsp;10.0.18.10:3' +
            this.guide('PAT confirmed: 192.168.1.11 (PC1 DHCP) → 10.0.18.9 (R1 e0/0 public IP).')
          );
        }
        if (this.r1Completion.natOverload) {
          return createStdout('(no translations — complete Task 3 DHCP relay first so PC1 gets an IP)' + this.guide('→ Configure "interface e0/1" + "ip helper-address 172.16.0.9" on Sw1.'));
        }
        return createStdout('(no translations — complete Task 1 NAT configuration first)');
      }

      // show ntp status
      if (sub1 === 'ntp' && sub2 === 'status') {
        if (this.sw1Completion.ntpServer && this.r1Completion.ntpMaster) {
          return createStdout(
            'Clock is synchronized, stratum 16, reference is 209.165.202.134<br>' +
            'clock offset is 0.00 msec, root delay is 0.00 msec' +
            this.guide('Sw1 clock is synchronized with R1 NTP server (209.165.202.134).')
          );
        }
        return createStdout('Clock is unsynchronized' + this.guide('Configure "ntp master" on R1 and "ntp server 209.165.202.134" on Sw1 first.'));
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(dev, x) {
      if (this[dev].mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first');
      const c = this[dev + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(`${this.devLabel(dev)} saved. ` + (this.saveDone ? '✓ Both devices saved — simulation complete!' : '→ Save the remaining device.')));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #sw1_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

